import {SearchDto} from "../../component/inquiry/dto/SearchDto";

export const GET = (seq: number): string => `
    query {
        getInquiry(seq: ${seq}) {
            inquiryDto {
                seq
                type
                isMember
                name
                email
                phone
                isCompleted
                reply
                createdAt
            }
            detailType
            content
        }
    }
`;

export const GET_INQUIRIES = (searchDto: SearchDto): string => `
    query {
        getInquiries(types: [${searchDto.types}], statusTypes: [${searchDto.statusTypes}], keywordType: ${searchDto.keywordType}, keyword: "${searchDto.keyword}", page: ${searchDto.page}) {
            items {
                seq
                type
                isMember
                name
                email
                phone
                createdAt
                isCompleted
                content
            }
            currentPage
            totalPage
            totalItems
        }
    }
`;